import { useTranslation } from 'react-i18next'

import { useSyncSaltoSpaceAccessPoints } from '@/api/building'
import { FieldRow, FieldValue } from '@/components/layout/field-row'
import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { Building } from '@/reducers/types'
import { getApiErrorMessage } from '@/utils/error'

interface SaltoSpaceCacheProps {
  building: Building
  isAdmin: boolean
}

export const SaltoSpaceCache = ({ building, isAdmin }: SaltoSpaceCacheProps) => {
  const { t } = useTranslation(['organisation'])
  const { mutateAsync: sync, isPending } = useSyncSaltoSpaceAccessPoints()

  const handleSync = async () => {
    try {
      await sync(building.id)
      toastFactory.success(t('organisation:places.other.toasts.saltoSynced'))
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  const description = !isAdmin
    ? t('organisation:places.other.saltoCache.adminOnly')
    : building.saltoSpaceAvailable
      ? t('organisation:places.other.saltoCache.description')
      : t('organisation:places.other.saltoCache.notConnected')

  return (
    <FieldRow label={t('organisation:places.building.saltoSpaceCache.label')}>
      <FieldValue>
        <Button
          disabled={!isAdmin || !building.saltoSpaceAvailable}
          loading={isPending}
          size="small"
          use="secondary"
          onClick={handleSync}
        >
          {t('organisation:places.building.saltoSpaceCache.syncButton')}
        </Button>
        <Typography size="text-small" color="black500">
          {description}
        </Typography>
      </FieldValue>
    </FieldRow>
  )
}
